// Lets any page tell the navbar that the user signed in or out, so the menu refreshes without a reload.
export const AUTH_CHANGED_EVENT = 'app:auth-changed'

export const notifyAuthChanged = () => {
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT))
}
